import { render, staticRenderFns } from "./PsoriasisJointInvestigationPhaseV2.vue?vue&type=template&id=64ee1288&scoped=true&"
import script from "./PsoriasisJointInvestigationPhaseV2.vue?vue&type=script&lang=js&"
export * from "./PsoriasisJointInvestigationPhaseV2.vue?vue&type=script&lang=js&"
import style0 from "./PsoriasisJointInvestigationPhaseV2.vue?vue&type=style&index=0&id=64ee1288&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee1288",
  null
  
)

export default component.exports